import { DoctorPatientDashboard } from "@/components/patient-management/DoctorPatientDashboard";

const DoctorPatientDashboardPage = () => {
  return <DoctorPatientDashboard />;
};

export default DoctorPatientDashboardPage;
